import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchResults } from '../searchResults';
import { CaseType } from './caseType';
import { ClientOppDescription } from './clientOppDescription';


@JsonObject('DescriptionSearchResults')
export class DescriptionSearchResults extends SearchResults {
    @JsonProperty('results', [ClientOppDescription])
    results: ClientOppDescription[] = [];
}